import { lazy } from "react";
import { Route } from "react-router-dom";
import Layout from "../../components/PageNavigation/Layout";

const LogisticsPage = lazy(() =>
  import("./pages/LogisticsPage")
);

// Export individual routes, not a component wrapper
export const logisticsRoutes = [
  <Route
    key="logistics"
    path="/logistics"
    element={
      <Layout>
        <LogisticsPage />
      </Layout>
    }
  />,
  // Add future routes here as more array items
  // <Route key="maintenance-guide-detail" path="/maintenance-guide/:id" element={<Layout><MaintenanceDetailPage /></Layout>} />,
];